<div class="wnl-header">

  @if (patient().isObstetric()) {
  <p>
    WNL: Alert, oriented, no distress. Bonding with baby if applicable, breasts soft and non-tender with no lumps or
    engorgement noted. Nipples intact and everted bilaterally.
  </p>
  <mat-checkbox [checked]="wnlManagerOB.allWNL" [indeterminate]="wnlManagerOB.someWNL()"
    (change)="wnlManagerOB.setAllWNL($event.checked)">
    All Within Normal Limits
  </mat-checkbox>
  } @else {
  <p>
    WNL: Alert, oriented, no distress.
  </p>
  <mat-checkbox [checked]="wnlManager.allWNL" [indeterminate]="wnlManager.someWNL()"
    (change)="wnlManager.setAllWNL($event.checked)">
    All Within Normal Limits
  </mat-checkbox>
  }
</div>

<div [formGroup]="formGroup()" class="form-container">
  <assessment-row title="LOC">
    <emr-input type="select" [hasWNL]="true" [control]="formGroup().controls.loc" [options]="locOptions"
      [default]="locDefault" [(wnl)]="wnlManagerOB.controlColl['loc'].wnl" (wnlChange)="wnlManagerOB.updateAllWNL()" />
  </assessment-row>

  <assessment-row title="Orientation">
    <emr-checkbox-group [control]="formGroup().controls.orientation" [options]="orientationOptions" />
  </assessment-row>

  <assessment-row title="Lethargic?">
    <emr-checkbox [control]="formGroup().controls.lethargic" label="Yes" />
  </assessment-row>

  <assessment-row title="Inappropriate for Age?">
    <emr-checkbox [control]="formGroup().controls.inappropriateForAge" label="Yes" />
  </assessment-row>

  <assessment-row title="In distress?">
    <emr-checkbox [control]="formGroup().controls.distress" label="Yes" />
  </assessment-row>

  @if (patient().isObstetric()) {
  <assessment-row title="Not bonding with baby appropriately">
    <emr-checkbox [control]="formGroup().controls.babyBonding" label="Yes" />
  </assessment-row>

  <assessment-row title="Breast Abnormalities Present?">
    <emr-checkbox [control]="formGroup().controls.hasBreastAbnormalities" label="Yes" />
  </assessment-row>

  @if (areBreastsAbnormal) {
  <assessment-row title="Nipple Abnormalities">
    <emr-input type="text" [control]="formGroup().controls.nippleAbnormalitiesNotes"></emr-input>
  </assessment-row>

  <assessment-row title="Breast Abnormalities">
    <emr-input type="text" [control]="formGroup().controls.breastAbnormalitiesNotes"></emr-input>
  </assessment-row>
  }
  } @else {
  <assessment-row title="LOC">
    <emr-input type="select" [hasWNL]="true" [control]="formGroup().controls.loc" [options]="locOptions"
      [default]="locDefault" [(wnl)]="wnlManager.controlColl['loc'].wnl" (wnlChange)="wnlManager.updateAllWNL()" />
  </assessment-row>

  <assessment-row title="Orientation">
    <emr-checkbox-group [control]="formGroup().controls.orientation" [options]="orientationOptions" />
  </assessment-row>

  <assessment-row title="Lethargic?">
    <emr-checkbox [control]="formGroup().controls.lethargic" label="Yes" />
  </assessment-row>

  <assessment-row title="Inappropriate for Age?">
    <emr-checkbox [control]="formGroup().controls.inappropriateForAge" label="Yes" />
  </assessment-row>

  <assessment-row title="In distress?">
    <emr-checkbox [control]="formGroup().controls.distress" label="Yes" />
  </assessment-row>
  }
</div>